import pythonApiClient from './pythonBaseApi';

/**
 * Consumos de comedor → proveedor externo (Logiflex / Cumbrak)
 * Envío vía cola Redis (async); el worker procesa hacia el endpoint productivo.
 */
export const consumoProveedorApi = {
  getDetalleTurno: (idTurnoCabecera) =>
    pythonApiClient.get(
      `/procesos/alimentacion/consumos-proveedor/turno/${idTurnoCabecera}/detalle`
    ),

  getEstadoCola: () =>
    pythonApiClient.get('/procesos/alimentacion/consumos-proveedor/cola/estado'),

  encolarConsumo: (idTurnoDetalle, { forzarReenvio = false, origen = 'popup' } = {}) =>
    pythonApiClient.post(
      `/procesos/alimentacion/consumos-proveedor/encolar/${idTurnoDetalle}`,
      null,
      {
        params: {
          forzar_reenvio: forzarReenvio,
          origen,
        },
      }
    ),

  encolarPendientesTurno: (idTurnoCabecera, { forzarReenvio = false } = {}) =>
    pythonApiClient.post(
      `/procesos/alimentacion/consumos-proveedor/turno/${idTurnoCabecera}/enviar-pendientes`,
      null,
      {
        params: {
          forzar_reenvio: forzarReenvio,
        },
      }
    ),

  /**
   * Fuerza reencolado Redis de consumos en_cola/procesando/reintento del turno
   * (colas huérfanas / worker caído, incluye días anteriores).
   */
  reencolarColaTurno: (idTurnoCabecera) =>
    pythonApiClient.post(
      `/procesos/alimentacion/consumos-proveedor/turno/${idTurnoCabecera}/reencolar-cola`
    ),

  /**
   * Reencola consumos con estado error del turno para reintento al proveedor.
   */
  reenviarErroresTurno: (idTurnoCabecera) =>
    pythonApiClient.post(
      `/procesos/alimentacion/consumos-proveedor/turno/${idTurnoCabecera}/reenviar-errores`
    ),

  getLogsEnvio: (idTurnoDetalle) =>
    pythonApiClient.get(
      `/procesos/alimentacion/consumos-proveedor/enviar/${idTurnoDetalle}/logs`
    ),
};

export default consumoProveedorApi;
